// „Meine Aufträge“ (Screen hausmeister/02): Karten der freigegebenen Tickets.
import { CaretRight, ClipboardText, MapPin } from '@phosphor-icons/react';
import { IconChip, LeerZustand, SeitenTitel, StatusChip, farbKlasse } from '../../components/portal/bausteine';
import type { HausmeisterTicket } from '../../lib/hausmeister/api';
import { adresse, auftragAnzahlText, datumLang, statusStufe, stufenLabel } from '../../lib/hausmeister/darstellung';
import { STUFE_STIL } from './symbole';

export function AuftragKarte({ ticket, gestapelt, onOeffnen }: { ticket: HausmeisterTicket; gestapelt: boolean; onOeffnen: () => void }) {
  const stufe = statusStufe(ticket.status);
  const stil = STUFE_STIL[stufe];
  const Symbol = stil.icon;
  const adr = adresse(ticket);
  return (
    <div className={gestapelt ? `p-stapel ${farbKlasse(stil.farbe)}` : ''} style={{ paddingBottom: gestapelt ? 12 : 0 }}>
      <button
        type="button"
        onClick={onOeffnen}
        data-tip="Auftrag öffnen"
        className={`p-glas p-hebt ${farbKlasse(stil.farbe)}`}
        style={{ width: '100%', textAlign: 'left', color: 'var(--p-w)', cursor: 'pointer', border: 'none', padding: '16px 16px 16px 14px', display: 'flex', alignItems: 'center', gap: 14 }}
      >
        <div className="p-glas-schimmer-links">
          <Symbol size={120} weight="duotone" className="p-wasserzeichen" style={{ right: 28, bottom: -30, opacity: 0.12 }} />
        </div>
        <div className="p-glas-rand" />
        <IconChip farbe={stil.farbe} icon={Symbol} groesse={50} radius={15} gedreht />
        <span style={{ minWidth: 0, flex: 1, display: 'flex', flexDirection: 'column', gap: 5 }}>
          <span style={{ fontSize: 16, fontWeight: 800, lineHeight: 1.25, letterSpacing: '-0.01em', overflowWrap: 'anywhere' }}>{ticket.titel}</span>
          {adr && (
            <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--p-w55)', display: 'flex', alignItems: 'center', gap: 5, minWidth: 0 }}>
              <MapPin size={12} weight="fill" style={{ flexShrink: 0 }} /><span className="p-kuerzen">{adr}</span>
            </span>
          )}
        </span>
        <span style={{ flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 10 }}>
          <StatusChip ton={stil.ton} gross>{stufenLabel(stufe)}</StatusChip>
          <CaretRight size={14} weight="bold" style={{ color: 'var(--p-w35)' }} />
        </span>
      </button>
    </div>
  );
}

export default function AuftragListe({ tickets, jetzt, onOeffnen }: {
  tickets: HausmeisterTicket[]; jetzt: Date; onOeffnen: (t: HausmeisterTicket) => void;
}) {
  return (
    <div className="p-rein" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <SeitenTitel oben={datumLang(jetzt)} titel="Meine Aufträge" rechts={tickets.length > 0 ? auftragAnzahlText(tickets.length) : undefined} />
      {tickets.length === 0 ? (
        <LeerZustand icon={ClipboardText} text="Keine Aufträge für Sie freigegeben" />
      ) : (
        <div className="hm-karten">
          {tickets.map((t, i) => (
            <AuftragKarte key={t.id} ticket={t} gestapelt={i === 0 && statusStufe(t.status) === 'in_bearbeitung'} onOeffnen={() => onOeffnen(t)} />
          ))}
        </div>
      )}
    </div>
  );
}
